
import { defineComponent, PropType } from 'vue'
import { iQuery, iFilter } from '../../QBE'
import * as treeService from './treeService'
import * as selectedOperandService from './selectedOperandService'
import * as advancedFilterservice from './advancedFilterService'
import Dialog from 'primevue/dialog'
import QBEAdvancedFilterDialogDescriptor from './QBEAdvancedFilterDialogDescriptor.json'
import QBEOperator from './QBEOperator.vue'

const deepcopy = require('deepcopy')

export default defineComponent({
    name: 'qbe-advanced-filter-dialog',
    components: { Dialog, QBEOperator },
    props: { visible: { type: Boolean }, query: { type: Object as PropType<iQuery> } },
    emits: ['save', 'close'],
    data() {
        return {
            QBEAdvancedFilterDialogDescriptor,
            expression: null as any,
            filters: [] as iFilter[],
            root: {} as any,
            selectedCount: 0,
            singleGroupSelected: false,
            getSelectedCount: selectedOperandService.getSelectedCount,
            isSingleGroupSelected: selectedOperandService.isSingleGroupSelected,
            sel: selectedOperandService.getSelected
        }
    },
    watch: {
        query: {
            handler() {
                this.loadData()
            },
            deep: true
        },
        visible(value: boolean) {
            if (value) this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            if (this.query) {
                this.expression = this.query.expression ? deepcopy(this.query?.expression) : {}
                this.filters = this.query.filters ? [...this.query.filters] : []
            }

            treeService.setFilterTree(deepcopy(this.expression))
            this.root = treeService.getFilterTree()
        },
        onSelectedChanged() {
            this.selectedCount = this.getSelectedCount()
            this.singleGroupSelected = this.isSingleGroupSelected()
        },
        group() {
            advancedFilterservice.group(treeService.getFilterTree(), selectedOperandService.getSelected())
            selectedOperandService.unSelectAll()
            this.root = treeService.getFilterTree()
        },
        ungroup() {
            advancedFilterservice.ungroup(treeService.getFilterTree(), selectedOperandService.getSelected()[0])
            selectedOperandService.unSelectAll()
            this.root = treeService.getFilterTree()
        },
        onTreeUpdated() {
            this.root = treeService.getFilterTree()
        },
        closeDialog() {
            selectedOperandService.unSelectAll()
            this.selectedCount = this.getSelectedCount()
            this.singleGroupSelected = this.isSingleGroupSelected()
            this.$emit('close')
        },
        save() {
            this.$emit('save', deepcopy(this.root))
            selectedOperandService.unSelectAll()
            this.selectedCount = this.getSelectedCount()
            this.singleGroupSelected = this.isSingleGroupSelected()
        }
    }
})
